exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.simulador_passo_pessoais[data-v-45902a64]{\n    margin-top: 50px;\n}\n", ""]);

// exports
